
<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("supportticketing") }}</div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Support Ticket')"
          variant="default"
          class="btn-blue"
          to="/cinema-manager/add-support-ticketing"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper mt-5">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selectedstatus && selectedstatus.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("status", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedstatus"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(st, stIndex) in status"
                  :key="stIndex"
                  @click="OnSelect(st)"
                  >{{ st.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th>{{ $tc("status", 1) }}</th>
            <th colspan="2">
              <img
                v-if="this.columnName != 'stm_subject'"
                @click="onSortValue('stm_subject', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('stm_subject', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('stm_subject', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              Subject
            </th>
            <th>Category</th>
            <th>Requester</th>
            <th>Requested</th>
          </tr>
        </thead>
        <tbody v-if="AllTickets.length > 0">
          <tr v-for="(ticket, ticketIndex) in AllTickets" :key="ticketIndex">
            <!-- <td>
              <div class="d-flex justify-content-between">
                <div>{{ ticket.st_status }}</div>

                <div>
                  <b-dropdown right variant="edit" class="ml-4">
                    <b-dropdown-item
                      v-if="$can('update', 'Support Ticket')"
                      @click="
                        goToRoute(
                          '/cinema-manager/edit-support-ticketing',
                          ticket
                        )
                      "
                    >
                      <span class="edit-pen"></span>
                      {{ $t("respond") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </td> -->
            <td>
              <div class="d-flex justify-content-between">
                <div>{{ ticket.st_status }}</div>

                <i
                  v-if="$can('update', 'Support Ticket')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  @click.prevent.stop="
                    goToRoute('/cinema-manager/edit-support-ticketing', ticket)
                  "
                  v-b-tooltip="'Respond'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td colspan="2">{{ ticket.stm_subject }}</td>
            <td>{{ ticket.stc_name }}</td>
            <td>{{ ticket.fullName || ticket.st_creator_customer_email }}</td>
            <td>{{ ticket.support_ticket_created_at | dateparse }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "",
      selectedstatus: "",
      selectedid: "",
      status: [
        { id: 0, name: "Resolved" },
        { id: 1, name: "Unresolved" },
      ],
      TicketList: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.GetAllTickets();
    this.getviewingnumber();
  },
  computed: {
    AllTickets() {
      let filteredList = [];

      if (this.selectedstatus.length > 0) {
        this.TicketList.map((x) => {
          if (x.st_status == this.selectedstatus) {
            filteredList.push(x);
          }
        });
        return filteredList;
      } else {
        return this.TicketList;
      }
    },
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetAllTickets();
      } else {
        this.currentPage = event;
        this.GetAllTickets();
      }
    },
    goToRoute: function (path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.st_id,
          status: item.st_status,
        },
      });
    },

    OnSelect: function (data) {
      this.selectedstatus = data.name;
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.GetAllTickets();
    },

    GetAllTickets: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      let loader = this.$loading.show();

      CinemasService.GetTickets(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TicketList = data.Records;

              this.TicketList.map((x) => {
                if (!x.st_creator_customer_email)
                  x.fullName = `${x.first_name || ""} ${x.middle_name || ""} ${
                    x.last_name || ""
                  }`;
              });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SupportTicketingComponents/listSupportTicketing.vue